export default async () => {
  const controller = await import(
    /* webpackChunkName: "DELCompareController-lib" */ '@/delonghi/Controllers/Compare/DELCompareController'
  );
  controller.default();
};
